// Shared health-board helpers (ADR-014): the green/yellow/red dot, tone/label maps, and the
// relative-age formatter used by both the System Status board (AdminDashboard) and the COI
// Pipeline panel (CoiPanel, WO A3). The COI backend adds a fourth "unknown" state (no data
// yet — reported, not alarmed) rendered as a slate dot.

/** Health incl. the COI backend's "unknown" (superset of /api/admin/status's 3 values). */
export type Health = "green" | "yellow" | "red" | "unknown";

export const HEALTH_TONE: Record<Health, "green" | "amber" | "red" | "slate"> = {
  green: "green",
  yellow: "amber",
  red: "red",
  unknown: "slate",
};

export const HEALTH_LABEL: Record<Health, string> = {
  green: "Healthy",
  yellow: "Degraded",
  red: "Down",
  unknown: "Unknown",
};

export function relativeAge(iso: string | null): string {
  if (!iso) return "never";
  const ms = Date.now() - new Date(iso).getTime();
  const mins = Math.round(ms / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.round(hrs / 24)}d ago`;
}

export function Dot({ health }: { health: Health }): JSX.Element {
  const color =
    health === "green"
      ? "bg-green-500"
      : health === "yellow"
        ? "bg-amber-500"
        : health === "red"
          ? "bg-red-500"
          : "bg-slate-400";
  return <span className={`inline-block h-2.5 w-2.5 rounded-full ${color}`} aria-label={HEALTH_LABEL[health]} />;
}
